import React from 'react';

export interface DisplayDate {
  date: Date | string;
  withTime?: boolean;
}

const FormatDisplayDate = ({ date, withTime }: DisplayDate) => {
  const day: string = new Date(date).toLocaleDateString();
  const time: string = new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <span>{withTime ? day + ' ' + time : day}</span>;
};

export default FormatDisplayDate;
